"use client";

import type { CodeVerifyStepProps } from "./types";
import { CodeVerifyStepDesktop } from "./steps/CodeVerifyStepDesktop";
import { CodeVerifyStepMobile } from "./steps/CodeVerifyStepMobile";
import { CodeVerifyStepPopup } from "./steps/CodeVerifyStepPopup";

export function CodeVerifyStep(props: CodeVerifyStepProps) {
  switch (props.variant) {
    case "desktop":
      return <CodeVerifyStepDesktop {...props} />;
    case "mobile":
      return <CodeVerifyStepMobile {...props} />;
    case "popup":
      return <CodeVerifyStepPopup {...props} />;
    default:
      return <CodeVerifyStepMobile {...props} />;
  }
}
